import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/checklist-3-months";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/wedding-checklist_/3-months")({
  head: SEO["/wedding-checklist/3-months"],
  component: () => <ContentPage path="/wedding-checklist/3-months" body={body} />,
});
